module.exports = __webpack_public_path__ + "static/media/undraw-before-dawn-bqrj.fcf28f33.svg";